import React from 'react'
import { Image, Row, Col } from 'react-bootstrap'


export const ChatWindowBulkSenderHeaderDesktop = ({ isSidebarClass }) => {
  return (
    <div className={`headchat ${isSidebarClass.first}`}>
      <Row>
        <Col md={5}>
          <ul className="activechat">
            <li>
              <div className="textchat">
                <h5> New Message to Selected Users </h5>
              </div>
            </li>
          </ul>
        </Col>
      </Row>
    </div>
  )
}

export const ChatWindowBulkSenderHeaderMobile = ({ handleSidebarClass }) => {
  return (
    <div className="res-header hideback">
      <div className="d-flex align-items-center h-100">
        <button className="btn" onClick={() => handleSidebarClass()} title='back'>
          <Image
            src={
              `https://d9apl513jlx0u.cloudfront.net/public_assets/public/assets/images/icons/${localStorage.getItem('isDark') === 'true' ? 'dark_back' : 'backBtn'}.svg`
            }
            alt="Back Btn"
          />
        </button>
        <span className="pink">
          New Message to Selected Users
        </span>
      </div>
    </div>
  )
}
